// End-to-end order testing against the real deployed backend, without real
// charges. Visiting the map with ?mode=test makes every backend call carry
// ?mode=test, which flips the PHP endpoints to a separate config holding
// Stripe *test* keys (see backend/order-mail-lib.php `order_is_test_mode`).
// Inert for normal visitors — the param has to be in the URL.

export const TEST_MODE =
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('mode') === 'test';

/** Backend endpoint path, with ?mode=test appended when testing. */
export function apiUrl(path: string): string {
  return TEST_MODE ? `${path}?mode=test` : path;
}
